import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Proovi kasutada erinevaid märksõnu.

  <span style="color:#85c1dc;">**FI:**</span>
  Kokeile eri avainsanoja.

  <span style="color:#85c1dc;">**RU:**</span>
  Попробуйте использовать разные ключевые слова.
*/
/* @__NO_SIDE_EFFECTS__ */
const m1616 = msg(
  mf`Proovi kasutada erinevaid märksõnu.`,
  mf`Kokeile eri avainsanoja.`,
  mf`Попробуйте использовать разные ключевые слова.`,
)

export { m1616 as 'w.module.no-results.search.suggestions.items.try-various-keywords' }